// src/data/mockData.js
//familyDinnerRecipes, slowCookerRecipes, latestRecipes, plantBasedRecipes , dateneightRecipes, chickenRecipes, pastaRecipes
// Categoriesi

import { video } from "framer-motion/client";
import burgerVideo from "../assets/burger.mp4";
import vid1 from "../assets/vid1.mp4";
import vid2 from "../assets/vid2.mp4";
import vid4 from "../assets/vid4.mp4";



export const categories = [
  {
    id: "familyDinnerRecipes",
    name: "Family Dinner",
    description: "Delicious family-friendly dinner recipes",
    image:
      "https://images.unsplash.com/photo-1584278858764-2ddcd7f228da",
    recipeCount: 10,
    video:burgerVideo,
  },
  {
    id: "slowCookerRecipes",
    name: "Slow Cooker",
    description: "Comforting slow-cooked meals  for busy days",
    image:
      "https://images.unsplash.com/photo-1605034298551-baacf17591d1",
    recipeCount: 10,
    video:vid1
  },
  {
    id: "latestRecipes",
    name: "Latest Recipes",
    description: "Hearty and satisfying dinner recipes",
    image:
      "https://images.unsplash.com/photo-1693422660544-014dd9f3ef73",
    recipeCount: 10,
    video:vid2
  },
  {
    id: "plantBasedRecipes",
    name: "Plant Based",
    description: "Delicious plant-based recipes for a healthy lifestyle",
    image:
      "https://images.unsplash.com/photo-1768326119181-5f3cfe0adb4c",
    recipeCount: 10,
    video:vid4
  },
  {
    id: "dateneightRecipes",
    name: "Date Night Recipes",
    description: "Classic Date Night recipes for a romantic evening",
    image:
      "https://images.unsplash.com/photo-1763627719097-a923a1e703a0",
    recipeCount:10,
      video:vid1
  },
  {
    id: "chickenRecipes",
    name: "Chicken Recipes",
    description: "Authentic and delicious chicken recipes",
    image:
      "https://images.unsplash.com/photo-1627900440398-5db32dba8db1",
    recipeCount: 10,
      video:vid2
  },
  {
    id: "pastaRecipes",
    name: "Pasta Recipes",
    description: "Spicy and flavorful pasta dishes",
    image:
      "https://images.unsplash.com/photo-1707604341704-74abdc25e52a",
    recipeCount: 10,
      video:vid4
  },
    {
    id: "chickenRecipes",
    name: "Chicken Recipes",
    description: "Authentic and delicious chicken recipes",
    image:
      "https://images.unsplash.com/photo-1627900440398-5db32dba8db1",
    recipeCount: 10,
  },
  {
    id: "pineappleRecipes",
    name: "Pineapple Recipes",
    description: "Delicious pineapple-based recipes",
    image:
      "https://images.unsplash.com/photo-1707604341704-74abdc25e52a",
    recipeCount: 10,
  },
  {
    id: "potatoRecipes",
    name: "Potato Recipes",
    description: "Hearty and satisfying potato-based recipes",
    image:
      "https://images.unsplash.com/photo-1584278858764-2ddcd7f228da",
    recipeCount: 10,
  },{
    id: "beefRecipes",
    name: "Beef Recipes",
    description: "Delicious beef-based recipes for every occasion",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTiwikR1Vm_RSCnydcZw6Vkb_hJdFopd-wSRw&s",
    recipeCount: 10,
  },{
    id: "healthyRecipes",
    name: "Healthy Recipes",
    description: "Nutritious and delicious healthy recipes",  
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPfgtklIk4gfS3s39szpMww46hTye3LR65gQ&s",
    recipeCount: 10,
  },{
    id: "vegetarianRecipes",
    name: "Vegetarian Recipes",
    description: "Delicious vegetarian recipes for a meat-free lifestyle",  
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSt4KJEyUjzIHHkxXJRF3wX4c8VRGFtFfAyFg&s",
    recipeCount: 10,
  },{
    id: "lowCarbRecipes",
    name: "Low Carb Recipes",
    description: "Tasty low-carb recipes for a healthy lifestyle",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9iw9S0v4DA2adCcfPOjakj7Yziy4CuSGfBA&s",
    recipeCount: 10,
  },{
    id: "highProteinRecipes",
    name: "High Protein Recipes",
    description: "Filling and nutritious high-protein recipes for muscle building and weight loss",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQNU5kNQ7QQdLlv_C0vLw0Zmojw4aPdKSlow&s",
    recipeCount: 10,
  },{
    id: "veganRecipes",
    name: "Vegan Recipes",
    description: "Delicious vegan recipes for a plant-based lifestyle", 
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2QsqT_xmVVRXyIsCZIFrS6ilx-fmAswoyaQ&s",
    recipeCount: 10,
  },{
    id: "breakfastRecipes",
    name: "Breakfast Recipes",
    description: "Delicious breakfast recipes to start your day off right", 
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQNU5kNQ7QQdLlv_C0vLw0Zmojw4aPdKSlow&s",
    recipeCount: 10,
  },{
    id:"lunchRecipes",
    name:"Lunch Recipes",
    description:"Tasty and satisfying lunch recipes for every occasion",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9gFUBAjJQK9jLN5yAQ2CbQ2d061b00QBiaQ&s",
    recipeCount: 10,
  },{
    id:"dinnerRecipes",
    name:"Dinner Recipes",
    description:"Hearty and delicious dinner recipes for the whole family",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9gFUBAjJQK9jLN5yAQ2CbQ2d061b00QBiaQ&s",
    recipeCount: 10,
  }
];
  

 

  



export const mockRecipes = [
  {
    id: '1',
    title: 'Pancakes',
    category: 'familyDinnerRecipes',
    difficulty: 'Easy',
    prepTime: 10,
    cookTime: 15,
    servings: 2,
    rating: 4.5,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNxHek8T-VrD5GA0-QzUH0zZEjeNtQKm-oUQ&s',
    description: 'Fluffy pancakes with syrup.',
    ingredients: ['Flour', 'Eggs', 'Milk', 'Sugar', 'Baking Powder'],
    instructions: [
      'Mix all ingredients.',
      'Heat a pan and pour batter.',
      'Cook until golden on both sides.',
    ],
    author: { name: 'Jane Doe', avatar: '/images/avatar.jpg' },
    reviews: 12,
  },
  {
    id: '2',
    title: 'Burger',
    category: 'familyDinnerRecipes',
    difficulty: 'Medium',
    prepTime: 15,
    cookTime: 20,
    servings: 1,
    rating: 4.2,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHp64n-eLrDSrY29_HCRIuP7-p89ndb18ezw&s',
    description: 'Juicy beef burger with cheese.',
    ingredients: ['Buns', 'Beef Patty', 'Cheese', 'Lettuce', 'Tomato'],
    instructions: [
      'Grill the beef patty.',
      'Toast the buns.',
      'Assemble burger with toppings.',
    ],
    author: { name: 'John Smith', avatar: '/images/avatar2.jpg' },
    reviews: 8,
  },
   {
    id: '3',
    title: 'Pancakes',
    category: 'familyDinnerRecipes',
    difficulty: 'Easy',
    prepTime: 10,
    cookTime: 15,
    servings: 2,
    rating: 4.5,
    image: 'https://restaurantindia.s3.ap-south-1.amazonaws.com/s3fs-public/content8101.jpg',
    description: 'Fluffy pancakes with syrup.',
    ingredients: ['Flour', 'Eggs', 'Milk', 'Sugar', 'Baking Powder'],
    instructions: [
      'Mix all ingredients.',
      'Heat a pan and pour batter.',
      'Cook until golden on both sides.',
    ],
    author: { name: 'Jane Doe', avatar: '/images/avatar.jpg' },
    reviews: 12,
  },
  {
    id: '2',
    title: 'Burger',
    category: 'latestRecipes',
    difficulty: 'Medium',
    prepTime: 15,
    cookTime: 20,
    servings: 1,
    rating: 4.2,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHp64n-eLrDSrY29_HCRIuP7-p89ndb18ezw&s',
    description: 'Juicy beef burger with cheese.',
    ingredients: ['Buns', 'Beef Patty', 'Cheese', 'Lettuce', 'Tomato'],
    instructions: [
      'Grill the beef patty.',
      'Toast the buns.',
      'Assemble burger with toppings.',
    ],
    author: { name: 'John Smith', avatar: '/images/avatar2.jpg' },
    reviews: 8,
  },
   {
    id: '1',
    title: 'Pancakes',
    category: 'familyDinnerRecipes',
    difficulty: 'Easy',
    prepTime: 10,
    cookTime: 15,
    servings: 2,
    rating: 4.5,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCCAD3yQhzVV1RnKjQt6SENdz0jRr1dvXs5A&s',
    description: 'Fluffy pancakes with syrup.',
    ingredients: ['Flour', 'Eggs', 'Milk', 'Sugar', 'Baking Powder'],
    instructions: [
      'Mix all ingredients.',
      'Heat a pan and pour batter.',
      'Cook until golden on both sides.',
    ],
    author: { name: 'Jane Doe', avatar: '/images/avatar.jpg' },
    reviews: 12,
  },
  {
    id: '2',
    title: 'Burger',
    category: 'familyDinnerRecipes',
    difficulty: 'Medium',
    prepTime: 15,
    cookTime: 20,
    servings: 1,
    rating: 4.2,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRoJ0RCxNrOLvYxHj8NSYEOBKgNLef73dF9A&s',
    description: 'Juicy beef burger with cheese.',
    ingredients: ['Buns', 'Beef Patty', 'Cheese', 'Lettuce', 'Tomato'],
    instructions: [
      'Grill the beef patty.',
      'Toast the buns.',
      'Assemble burger with toppings.',
    ],
    author: { name: 'John Smith', avatar: '/images/avatar2.jpg' },
    reviews: 8,
  },
   {
    id: '1',
    title: 'Pancakes',
    category: 'familyDinnerRecipes',
    difficulty: 'Easy',
    prepTime: 10,
    cookTime: 15,
    servings: 2,
    rating: 4.5,
    image: 'https://res.cloudinary.com/jerrick/image/upload/d_642250b563292b35f27461a7.png,f_jpg,q_auto,w_720/64e5ad44a17f6a001d7e19b8.jpg',
    description: 'Fluffy pancakes with syrup.',
    ingredients: ['Flour', 'Eggs', 'Milk', 'Sugar', 'Baking Powder'],
    instructions: [
      'Mix all ingredients.',
      'Heat a pan and pour batter.',
      'Cook until golden on both sides.',
    ],
    author: { name: 'Jane Doe', avatar: '/images/avatar.jpg' },
    reviews: 12,
  },
  {
    id: '2',
    title: 'Burger',
    category: 'familyDinnerRecipes',
    difficulty: 'Medium',
    prepTime: 15,
    cookTime: 20,
    servings: 1,
    rating: 4.2,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJr-Y7FEzAidqMKnxHJU6CVgu2stq1C9vAMA&s',
    description: 'Juicy beef burger with cheese.',
    ingredients: ['Buns', 'Beef Patty', 'Cheese', 'Lettuce', 'Tomato'],
    instructions: [
      'Grill the beef patty.',
      'Toast the buns.',
      'Assemble burger with toppings.',
    ],
    author: { name: 'John Smith', avatar: '/images/avatar2.jpg' },
    reviews: 8,
  },
   {
    id: '1',
    title: 'Pancakes',
    category: 'familyDinnerRecipes',
    difficulty: 'Easy',
    prepTime: 10,
    cookTime: 15,
    servings: 2,
    rating: 4.5,
    image: 'https://cloudfront.omsphoto.com/wp-content/uploads/2020/09/OMS-Photo-dinner-food-photography-AaronVan-orlando-photographer-02.jpg',
    description: 'Fluffy pancakes with syrup.',
    ingredients: ['Flour', 'Eggs', 'Milk', 'Sugar', 'Baking Powder'],
    instructions: [
      'Mix all ingredients.',
      'Heat a pan and pour batter.',
      'Cook until golden on both sides.',
    ],
    author: { name: 'Jane Doe', avatar: '/images/avatar.jpg' },
    reviews: 12,
  },
  {
    id: '2',
    title: 'Burger',
    category: 'familyDinnerRecipes',
    difficulty: 'Medium',
    prepTime: 15,
    cookTime: 20,
    servings: 1,
    rating: 4.2,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrCrcy4s5HbTri3ScpVn3JPietRn4jP21D-Q&s',
    description: 'Juicy beef burger with cheese.',
    ingredients: ['Buns', 'Beef Patty', 'Cheese', 'Lettuce', 'Tomato'],
    instructions: [
      'Grill the beef patty.',
      'Toast the buns.',
      'Assemble burger with toppings.',
    ],
    author: { name: 'John Smith', avatar: '/images/avatar2.jpg' },
    reviews: 8,
  },
   {
    id: '1',
    title: 'Pancakes',
    category: 'familyDinnerRecipes',
    difficulty: 'Easy',
    prepTime: 10,
    cookTime: 15,
    servings: 2,
    rating: 4.5,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1UH5HuDqCyH6y-pvnMwVwzGdbrEWSkk3UTQ&s',
    description: 'Fluffy pancakes with syrup.',
    ingredients: ['Flour', 'Eggs', 'Milk', 'Sugar', 'Baking Powder'],
    instructions: [
      'Mix all ingredients.',
      'Heat a pan and pour batter.',
      'Cook until golden on both sides.',
    ],
    author: { name: 'Jane Doe', avatar: '/images/avatar.jpg' },
    reviews: 12,
  },
  {
    id: '2',
    title: 'Burger',
    category: 'familyDinnerRecipes',
    difficulty: 'Medium',
    prepTime: 15,
    cookTime: 20,
    servings: 1,
    rating: 4.2,
    image: 'https://images.squarespace-cdn.com/content/v1/6212fcd24628365d6df79797/1645411921804-RGTQ5K65N7SQJLCDNQSI/vanilla-ice-cream-waffles.jpg',
    description: 'Juicy beef burger with cheese.',
    ingredients: ['Buns', 'Beef Patty', 'Cheese', 'Lettuce', 'Tomato'],
    instructions: [
      'Grill the beef patty.',
      'Toast the buns.',
      'Assemble burger with toppings.',
    ],
    author: { name: 'John Smith', avatar: '/images/avatar2.jpg' },
    reviews: 8,
  },
   {
    id: '1',
    title: 'Pancakes',
    category: 'familyDinnerRecipes',
    difficulty: 'Easy',
    prepTime: 10,
    cookTime: 15,
    servings: 2,
    rating: 4.5,
    image: 'https://cloudfront.omsphoto.com/wp-content/uploads/2020/09/OMS-Photo-dinner-food-photography-AaronVan-orlando-photographer-02.jpg',
    description: 'Fluffy pancakes with syrup.',
    ingredients: ['Flour', 'Eggs', 'Milk', 'Sugar', 'Baking Powder'],
    instructions: [
      'Mix all ingredients.',
      'Heat a pan and pour batter.',
      'Cook until golden on both sides.',
    ],
    author: { name: 'Jane Doe', avatar: '/images/avatar.jpg' },
    reviews: 12,
  },
  {
    id: '2',
    title: 'Burger',
    category: 'familyDinnerRecipes',
    difficulty: 'Medium',
    prepTime: 15,
    cookTime: 20,
    servings: 1,
    rating: 4.2,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrCrcy4s5HbTri3ScpVn3JPietRn4jP21D-Q&s',
    description: 'Juicy beef burger with cheese.',
    ingredients: ['Buns', 'Beef Patty', 'Cheese', 'Lettuce', 'Tomato'],
    instructions: [
      'Grill the beef patty.',
      'Toast the buns.',
      'Assemble burger with toppings.',
    ],
    author: { name: 'John Smith', avatar: '/images/avatar2.jpg' },
    reviews: 8,
  }, {
    id: '1',
    title: 'Pancakes',
    category: 'familyDinnerRecipes',
    difficulty: 'Easy',
    prepTime: 10,
    cookTime: 15,
    servings: 2,
    rating: 4.5,
    image: 'https://cloudfront.omsphoto.com/wp-content/uploads/2020/09/OMS-Photo-dinner-food-photography-AaronVan-orlando-photographer-02.jpg',
    description: 'Fluffy pancakes with syrup.',
    ingredients: ['Flour', 'Eggs', 'Milk', 'Sugar', 'Baking Powder'],
    instructions: [
      'Mix all ingredients.',
      'Heat a pan and pour batter.',
      'Cook until golden on both sides.',
    ],
    author: { name: 'Jane Doe', avatar: '/images/avatar.jpg' },
    reviews: 12,
  },
  {
    id: '2',
    title: 'Burger',
    category: 'familyDinnerRecipes',
    difficulty: 'Medium',
    prepTime: 15,
    cookTime: 20,
    servings: 1,
    rating: 4.2,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrCrcy4s5HbTri3ScpVn3JPietRn4jP21D-Q&s',
    description: 'Juicy beef burger with cheese.',
    ingredients: ['Buns', 'Beef Patty', 'Cheese', 'Lettuce', 'Tomato'],
    instructions: [
      'Grill the beef patty.',
      'Toast the buns.',
      'Assemble burger with toppings.',
    ],
    author: { name: 'John Smith', avatar: '/images/avatar2.jpg' },
    reviews: 8,
  },
   {
    id: '1',
    title: 'Pancakes',
    category: 'familyDinnerRecipes',
    difficulty: 'Easy',
    prepTime: 10,
    cookTime: 15,
    servings: 2,
    rating: 4.5,
    image: 'https://cloudfront.omsphoto.com/wp-content/uploads/2020/09/OMS-Photo-dinner-food-photography-AaronVan-orlando-photographer-02.jpg',
    description: 'Fluffy pancakes with syrup.',
    ingredients: ['Flour', 'Eggs', 'Milk', 'Sugar', 'Baking Powder'],
    instructions: [
      'Mix all ingredients.',
      'Heat a pan and pour batter.',
      'Cook until golden on both sides.',
    ],
    author: { name: 'Jane Doe', avatar: '/images/avatar.jpg' },
    reviews: 12,
  },
  {
    id: '2',
    title: 'Burger',
    category: 'familyDinnerRecipes',
    difficulty: 'Medium',
    prepTime: 15,
    cookTime: 20,
    servings: 1,
    rating: 4.2,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-iUS6aX28thwkdlBIOdkUL1fJexYuKIbGBb_SHiLHSw&s',
    description: 'Juicy beef burger with cheese.',
    ingredients: ['Buns', 'Beef Patty', 'Cheese', 'Lettuce', 'Tomato'],
    instructions: [
      'Grill the beef patty.',
      'Toast the buns.',
      'Assemble burger with toppings.',
    ],
    author: { name: 'John Smith', avatar: '/images/avatar2.jpg' },
    reviews: 8,
  },
];


export const mockUser = {
  id: '1',
  name: 'Food Box User',
  email: 'user@example.com',
  avatar: 'https://media.istockphoto.com/id/1437816897/photo/business-woman-manager-or-human-resources-portrait-for-career-success-company-we-are-hiring.jpg?s=612x612&w=0&k=20&c=tyLvtzutRh22j9GqSGI33Z4HpIwv9vL_MZw_xOE19NQ=',
  bio: 'Food enthusiast and home chef. Love experimenting with new recipes!',
  recipesCount: 15,
  followersCount: 342,
  followingCount: 128,
};